import { baseQuery } from '../baseQuery';

type PatchSubscriptionBody = {
  status?: string;
  end_date?: string;
  close_reason?: string;
  comments?: string;
  email_invoice?: 0 | 1;
  service_customer_id?: number;
};

type PatchSubscriptionParams = {
  id: number;
  body: PatchSubscriptionBody;
};

export const patchSubscription = async ({ id, body }: PatchSubscriptionParams) => {
  return await baseQuery(`subscriptions/${id}`, {
    type: 'PATCH',
    body,
  });
};
